import React from 'react';
import ServicePageTemplate, { ALL_SERVICES } from './ServicePageTemplate';

const pageData = {
  seo: {
    title: 'Web & Mobile App Development Company | RojrzTech',
    description:
      'RojrzTech builds custom web and mobile applications — scalable, secure, and high-performing. Expert React, Node.js, Flutter, iOS & Android development.',
  },
  hero: {
    badge: 'WEB & MOBILE APP EXPERTS',
    slides: [
      {
        heading: { pre: 'Build', gold: 'Powerful Web & Mobile', post: 'Applications' },
        subheading:
          'Transform your business idea into a high-performing digital product. We build scalable, secure, and stunning web and mobile applications tailored to your needs.',
        pills: ['React', 'Node.js', 'Flutter', 'iOS', 'Android'],
        image: '/Web1.jpeg',
      },
      {
        heading: { pre: 'Scalable Apps That', gold: 'Drive Business Growth' },
        subheading:
          'From startups to enterprises, we build web and mobile apps that scale with your business, delight your users, and maximize your revenue.',
        pills: ['PWA', 'SaaS', 'REST API', 'Cloud', 'Cross-Platform'],
        image: '/Web2.jpeg',
      },
      {
        heading: { pre: 'From Idea to', gold: 'Live Product', post: 'in Record Time' },
        subheading:
          'Our agile development process ensures rapid delivery without compromising on quality, security, or performance — getting you to market faster.',
        pills: ['Agile', 'MVP', 'Custom Build', 'Secure', 'Tested'],
        image: '/Web.jpeg',
      },
    ],
  },
  servicesCards: {
    title: 'Our Comprehensive Web & Mobile App Development Services',
    subtitle:
      'As one of the most trusted app development agencies, we ensure our applications meet your specific needs. Here are the types of apps we create for you:',
    cards: [
      {
        icon: '💻',
        title: 'Custom Web Application Development',
        description:
          'We build bespoke web applications tailored to your unique business processes, ensuring scalability, performance, and seamless user experience.',
      },
      {
        icon: '📱',
        title: 'Mobile App Development',
        description:
          'Native and cross-platform mobile apps for iOS and Android that deliver seamless, engaging user experiences and high performance.',
      },
      {
        icon: '⚡',
        title: 'Progressive Web Apps (PWA)',
        description:
          'Lightning-fast web apps that work offline and feel like native apps, combining the very best of web and mobile technology.',
      },
      {
        icon: '☁️',
        title: 'SaaS Application Development',
        description:
          'Scalable Software-as-a-Service platforms with multi-tenancy, subscription management, and robust APIs for global businesses.',
      },
      {
        icon: '🔗',
        title: 'API Development & Integration',
        description:
          'RESTful and GraphQL APIs that connect your systems, enable third-party integrations, and power your entire digital ecosystem.',
      },
      {
        icon: '🏢',
        title: 'Enterprise App Development',
        description:
          'Mission-critical enterprise applications with advanced security, compliance, and scalability built in from day one of development.',
      },
    ],
  },
  features: {
    title: 'Web & Mobile App Development Services for Accelerated Business Growth',
    subtitle:
      'Develop custom apps that enhance your reputation, elevate your presence, and expand your revenue streams across all platforms.',
    items: [
      'User-Centric Design',
      'Real-time Notifications',
      'Advanced Analytics',
      'Social Media Integration',
      'Offline Functionality',
      'Augmented Reality',
      'Geolocation Features',
      'Secure Payment Gateway',
      'Cloud Integration',
      'Multi-Platform Support',
      'QR / Barcode Scanning',
      'Enhanced Security',
    ],
  },
  excellence: {
    title: 'Collaborative Excellence',
    subtitle:
      "At RojrzTech, we prioritize collaboration to ensure the best outcomes for our clients. We maintain constant communication, refining your ideas until you're completely satisfied with our services.",
    cards: [
      {
        icon: '🎯',
        title: 'Intuitive User Interfaces',
        description:
          'Our main objective is to develop user-friendly interfaces and responsive applications that users genuinely love using.',
      },
      {
        icon: '🔒',
        title: 'Secure and Reliable Deployment',
        description:
          'Our developers and engineers ensure robust coding and secure deployment across all platforms and environments.',
      },
      {
        icon: '⭐',
        title: 'Versatile Feature Sets',
        description:
          'Our mobile apps are designed to be compatible with a variety of devices and platforms, giving your users maximum flexibility.',
      },
      {
        icon: '📱',
        title: 'Scalable & User-Friendly',
        description:
          'We use the latest tools to create visually appealing and engaging apps that grow and evolve with your business.',
      },
      {
        icon: '✏️',
        title: 'Tailored Designs & Features',
        description:
          'Our top developers craft custom-made applications to meet your specific needs, preferences, and business requirements.',
      },
      {
        icon: '🚀',
        title: 'High Performance & Efficiency',
        description:
          'Beyond aesthetics, our apps are optimized for maximum efficiency, loading speed, and performance on all devices.',
      },
    ],
  },
  relatedServices: ALL_SERVICES.filter((s) => s.href !== '/services/web-mobile-apps'),
};

const WebMobileApps = () => <ServicePageTemplate pageData={pageData} />;
export default WebMobileApps;
